import { createContext, useContext } from 'react';
import { DraggableProvided, DraggableStateSnapshot } from '@hello-pangea/dnd';

type IDraggableContext = {
  draggableProvided?: DraggableProvided;
  isDragging: boolean;
  moveToBack: VoidFunction;
  moveToFront: VoidFunction;
  snapshot?: DraggableStateSnapshot;
};

export const DraggableContext = createContext<IDraggableContext>({
  moveToBack: () => void 0,
  moveToFront: () => void 0,
  isDragging: false,
});

export const useDraggableContext = () => useContext(DraggableContext);

export default useDraggableContext;
